import { render, staticRenderFns } from "./QuotesTable.vue?vue&type=template&id=928b6872&scoped=true"
import script from "./QuotesTable.vue?vue&type=script&lang=js"
export * from "./QuotesTable.vue?vue&type=script&lang=js"
import style0 from "./QuotesTable.vue?vue&type=style&index=0&id=928b6872&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "928b6872",
  null
  
)

export default component.exports